export const description =
  "La VMC double flux récupère 70 à 90 % des calories de l'air vicié et filtre l'air entrant. Aides cumulables MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 % 2026.";
